var giphy_viewer_default = {
  "giphyWrapper": "rW-AU",
  "giphy_player": "_0nAfH",
  "playIcon": "ZO3NF",
  "gifRatio": "_8C4T4"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
